export const ProcessMonitorIcon = () => (
    <svg className="w-7 h-7" fill="none" viewBox="0 0 32 29">
        <g>
            <path
                d="M28.0003 1H4.00004C2.34316 1 1 2.34314 1 3.99999V19C1 20.6568 2.34316 22 4.00004 22H28.0003C29.6572 22 31.0004 20.6568 31.0004 19V3.99999C31.0004 2.34314 29.6572 1 28.0003 1Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path d="M16.0001 22.0004V28.0004" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            <path d="M10 28H22.0002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            <path d="M8.5 10.7507L13.7501 16.0007L24.2502 5.50067" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </g>
    </svg>
);
